export default __webpack_public_path__ + "static/media/Bids.a9242eb3.svg";